import React from 'react';

const RadioField = (props) => {
  const {
          type,
          value,
          id,
          className,
          name,
          onChange,
        } = props;

  return (<input
    {...props}
    id={id}
    type={type}
    value={value}
    className={className}
    name={name}
    onChange={onChange}
  />);
};

RadioField.defaultProps = {
  type:         'radio',
  autoComplete: 'off',
};

export default RadioField;
